// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidget-modulecontent__WMKql";
export { _1 as "content" }
